/*
 * Copyright (c) 2021 LNBIG.com
 * All rights reserved.
 */

import dbg from "debug"
const debug = dbg('lnbig:mixin:countdown')

export default {
    props: {
        expires:   Number,
        countdown: Number,
    },

    data() {
        return {
            currentCountdown: this.countdown,
            countdownInterval: null,
            startedCountdown: this.countdown,
        }
    },

    computed: {
        progress() {
            if (this.compExpires)
                return Math.round(this.currentCountdown / this.compExpires * 100)
            return 0
        },
        compCountdown() { return this.countdown },
        compExpires() { return this.expires },
        startTimeForCountdown() { return this.$store.state.openChannel.startTimeForLnurlCountdown }
    },

    watch: {
        compExpires: function () { this.startCountdown() },
        compCountdown: function () { this.startCountdown() }
    },

    methods: {
        getCurrentCountdown() {
            let result = Math.floor(this.startedCountdown - (Date.now() - this.startTimeForCountdown) / 1000)
            return result < 0 ? 0 : result
        },

        startCountdown() {
            debug('startCountdown')
            this.stopCountdown()
            if (this.compExpires) {
                this.currentCountdown = this.startedCountdown = this.compCountdown

                this.countdownInterval = setInterval(() => {
                    this.currentCountdown = this.getCurrentCountdown()
                    if (! this.currentCountdown)
                        this.stopCountdown()
                }, 1000)
            }
        },

        stopCountdown() {
            debug("stopCountdown")
            if (this.countdownInterval) {
                clearInterval(this.countdownInterval)
                this.countdownInterval = null
            }
        }
    },

}
